<script setup lang="ts" name="FormWizardVerticalHeaderTab">
import FormWizardHorizontalTabTitle from '~/components/FormWizardHorizontalTabTitle.vue';
import StepperHeaderCircle from '~/components/StepperHeaderCircle.vue';

defineProps<{
  isActive: boolean;
  isCompleted: boolean;
  step: number;
  title?: string;
  disabled?: boolean;
}>();
</script>

<template>
  <div class="flex items-center gap-x-2">
    <StepperHeaderCircle
      :isActive="isActive"
      :step="step"
      :isCompleted="isCompleted"
      :disabled="disabled"
    />

    <FormWizardHorizontalTabTitle
      v-if="title"
      :isActive="isActive"
      :isCompleted="isCompleted"
      :title="title"
      :disabled="disabled"
    />
  </div>
</template>
